import { PromiseResponse } from '@types';

import {
  AppointmentGuideFormValues,
  PatientData,
} from 'features/tissInvoicing/types/appointmentGuide';
import { iclinicApi, apiTissInvoicing } from '..';

export const fetchPatientData = (
  patientId: number,
): PromiseResponse<PatientData[]> =>
  iclinicApi(`/patients/patient/${patientId}/`);

export const saveGuideData = (data: AppointmentGuideFormValues) =>
  apiTissInvoicing.post(`/appointment-guide/`, data);
